import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  color: white;
  background-color: #B6936C;
  justify-content: space-evenly;
  align-items: center;
  padding: 40px 0;
  @media (max-width: 1000px) {
    flex-direction: row;
    justify-content: space-evenly;
    padding: 20px 20px;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 1000px) {
    display: ${props => props.hideMobile ? 'none' : 'flex'};
  }
`;

const Title = styled.h3`
  font-weight: bold;
`;

const Link = styled.a`
  color: white;
  &:hover {
    color: white;
  }
`;

const Paragraph = styled.p`
  font-weight: ${props => props.big ? 'bold' : 'normal'};
  font-size: ${props => props.big ? '16px' : '14px'};
  padding: 0;
  margin: 0;
  text-align: ${props => props.link ? 'center' : 'right'};
  @media (max-width: 768px) {
    font-size: 12px;
    text-align: right;
  }
`;

const ImageContainer = styled.div`
  max-width: 200px;
  @media (max-width: 768px) {
    max-width: 50%;
    padding-right: 20px;
  }
`;

export {
  Container,
  Column,
  Title,
  Link,
  Paragraph,
  ImageContainer,
};